import React, { useEffect, useMemo } from 'react'
import { Grid, Table, TableHead, TableBody, TableRow, TableCell, Paper, LinearProgress } from '@material-ui/core'

import { BlacklistOptions } from 'components'

const renderPassenger = (passenger, index) => {
  const { id, firstName, lastName, lastModified, phone, userName, userRole } = passenger

  return (
    <TableRow key={id}>
      <TableCell padding='dense'>
        <BlacklistOptions passenger={passenger} />
      </TableCell>

      <TableCell padding='dense'>
        {index + 1}
      </TableCell>

      <TableCell padding='dense'>
        {firstName}
      </TableCell>

      <TableCell padding='dense'>
        {lastName}
      </TableCell>

      <TableCell padding='dense'>
        {phone}
      </TableCell>

      <TableCell padding='dense'>
        {userName} ({userRole})
      </TableCell>

      <TableCell padding='dense'>
        { typeof lastModified === "string" && lastModified.split(' ')[0] }
      </TableCell>
    </TableRow>
  )
}

export const BlacklistBase = ({
  classes, blacklistBookings, getBlacklistBookings, isLoading
}) => {
  useEffect(() => {
    getBlacklistBookings()
  }, [getBlacklistBookings])

  return (
    <Grid
      container
      wrap='nowrap'
      spacing={32}
      className={classes.container}
      component={Paper}
    >
      <Grid xs item>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell padding='dense' />

              <TableCell padding='dense'>
                №
              </TableCell>

              <TableCell padding='dense'>
                Імя
              </TableCell>

              <TableCell padding='dense'>
                Прізвище
              </TableCell>

              <TableCell padding='dense'>
                Телефон
              </TableCell>

              <TableCell padding='dense'>
                Добавив(-ла)
              </TableCell>

              <TableCell padding='dense'>
                Дата добавлення
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {!isLoading && !blacklistBookings.length && (
              <TableRow>
                <TableCell
                  colSpan='10'
                  className={classes.emptyBookingsCell}
                >
                  Чорний список порожній
                </TableCell>
              </TableRow>
            )}

            {isLoading && (
              <TableRow>
                <TableCell colSpan='9'>
                  <LinearProgress />
                </TableCell>
              </TableRow>
            )}

            {!isLoading && blacklistBookings.map(renderPassenger)}
          </TableBody>
        </Table>
      </Grid>
    </Grid>
  )
}



// WEBPACK FOOTER //
// ./src/components/Blacklist/Blacklist.js